<template>
  <v-container>
    <v-card class="pa-5">
      <v-card-title>Agregar Términos a Factura</v-card-title>
      <v-file-input
        v-model="archivoFactura"
        label="Sube la factura generada"
        accept="application/pdf"
      ></v-file-input>
      
      <v-btn color="primary" @click="procesarFactura" :loading="cargando">
        Generar Factura con Términos
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      archivoFactura: null,
      cargando: false
    };
  },
  methods: {
    async procesarFactura() {
      if (!this.archivoFactura) {
        alert("Selecciona un PDF primero");
        return;
      }

      this.cargando = true;
      let formData = new FormData();
      formData.append("archivoPdf", this.archivoFactura);

      try {
        let configuracion = {
          headers: { 
            "Authorization": "Bearer " + this.$store.state.token,
            "Content-Type": "multipart/form-data"
          },
          responseType: 'blob' // ¡IMPORTANTE PARA DESCARGAR ARCHIVOS!
        };

        const response = await axios.post('api/Facturas/AgregarTerminosAlPdf', formData, configuracion);

        // Crear una URL en el navegador para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.archivoFactura.name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

      } catch (error) {
        console.error("Error al modificar el PDF", error);
        alert("Ocurrió un error al procesar la factura");
      } finally {
        this.cargando = false;
      }
    }
  }
}
</script>